import axios from '@/libs/api.request'

export const getNewsinfolist = (page, limit, key, filterParams) => {
  // 构建参数对象
  let params = {
    page,
    limit
  }

  // 如果有关键字搜索
  if (key) {
    params.key = key
  }

  // 如果有过滤参数对象
  if (filterParams && typeof filterParams === 'object') {
    // 状态过滤
    if (filterParams.state) {
      params.state = filterParams.state
    }
    // 类型过滤
    if (filterParams.type) {
      params.type = filterParams.type
    }
    // 模块过滤（多选，逗号分隔）
    if (filterParams.ctype) {
      params.ctype = filterParams.ctype
    }
  }

  return axios.request({
    url: '/v1/newsinfo/newsinfo/',
    method: 'get',
    params
  })
}

export const operationNewsinfo = (data, meth) => {
  return axios.request({
    url: '/v1/newsinfo/newsinfo/',
    method: meth,
    data
  })
}

export const uploadNewsImage = (formData) => {
  return axios.request({
    url: '/v1/newsinfo/upload/',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
